import { Paper, Stack } from "@mui/material"
import { useCheckoutContext } from "../../../../core/hooks/useCheckoutContext"
import CheckoutHeader6 from "./CheckoutHeader"
import DetailProductItem7 from "./DetailProductItem"

const CheckoutCoverImage8 = () => {
  const { productPrice, installment } = useCheckoutContext()

  const installmentFirst = installment?.original?.find(
    (pi) => pi.installmentNumber === 1
  )
  const value =
    installmentFirst?.value ??
    productPrice?.firstPurchasePrice ??
    productPrice?.value

  return (
    <>
      <CheckoutHeader6 />
      <Stack direction="column" sx={{ px: { xs: 1, sm: 3 } }} width="100%">
        <Paper
          elevation={0}
          sx={{
            border: "1px solid #DCDDDE",
            borderRadius: "20px",
            p: 0,
            m: 0,
          }}
        >
          <Stack
            direction="column"
            spacing={1}
            width="100%"
            sx={{ py: 1, px: 0.5 }}
          >
            <DetailProductItem7
              productImageUrl={productPrice?.productImageUrl}
              productName={productPrice?.productName}
              productDescription={productPrice?.productDescription}
              value={value}
            />
          </Stack>
        </Paper>
      </Stack>
    </>
  )
}

export default CheckoutCoverImage8
